"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitEmailEvent = exports.sendAgainForgottenPasswordEvent = exports.resetPasswordSubmitEvent = exports.resetPasswordSentWithSuccessEvent = exports.resetPasswordPageDisplayEvent = exports.resetPasswordFormSubmitEvent = exports.resetPasswordDisplayEvent = exports.onPageError = exports.onPageDisplay = exports.loginPasswordFormDisplayEvent = exports.loginEmailFormDisplayEvent = exports.loginByProviderEvent = exports.formSubmitEvent = exports.forgotPasswordEvent = exports.cdlEvent = void 0;
var _tms = require("integration-web-core--socle/js/assets/commons/_tms");
var cdlEvent = exports.cdlEvent = "cdl_event";

// Please add any new event to this documentation https://app.gitbook.com/o/0gRlAkSocTvnN36NTnDZ/s/NpjqGQPShKi0MXqO5Nft/technical-stuffs/piano-events-we-cover

var resetPasswordDisplayEvent = exports.resetPasswordDisplayEvent = function resetPasswordDisplayEvent(loginOrigin) {
  return {
    event_name: 'step.display',
    event_data: {
      funnel_name: loginOrigin ? 'checkout' : 'login stand alone',
      step_name: 'forgotten password',
      feature_name: 'login'
    }
  };
};
var resetPasswordSubmitEvent = exports.resetPasswordSubmitEvent = function resetPasswordSubmitEvent(loginOrigin) {
  return {
    event_name: 'step.submit',
    event_data: {
      funnel_name: loginOrigin ? 'checkout' : 'login stand alone',
      step_name: 'forgotten password',
      feature_name: 'login'
    }
  };
};
var resetPasswordSentWithSuccessEvent = exports.resetPasswordSentWithSuccessEvent = function resetPasswordSentWithSuccessEvent(loginOrigin) {
  return {
    event_name: 'step.display',
    event_data: {
      funnel_name: loginOrigin ? 'checkout' : 'login stand alone',
      step_name: 'email sent',
      feature_name: 'login'
    }
  };
};
var resetPasswordPageDisplayEvent = exports.resetPasswordPageDisplayEvent = {
  event_name: 'step.display',
  event_data: {
    step_name: 'new password',
    feature_name: 'forgotten password'
  }
};
var resetPasswordFormSubmitEvent = exports.resetPasswordFormSubmitEvent = {
  event_name: 'step.submit',
  event_data: {
    step_name: 'reinitiate password',
    feature_name: 'forgotten password'
  }
};
var loginEmailFormDisplayEvent = exports.loginEmailFormDisplayEvent = function loginEmailFormDisplayEvent(loginCheckout) {
  return {
    event_name: 'step.display',
    event_data: {
      funnel_name: loginCheckout ? 'checkout' : 'login stand alone',
      step_name: 'enter email',
      step_number: 1,
      feature_name: 'login'
    }
  };
};
var submitEmailEvent = exports.submitEmailEvent = function submitEmailEvent(loginCheckout) {
  return {
    event_name: 'step.submit',
    event_data: {
      funnel_name: loginCheckout ? 'checkout' : 'login stand alone',
      step_name: 'enter email',
      step_number: 1,
      feature_name: 'login'
    }
  };
};
var loginPasswordFormDisplayEvent = exports.loginPasswordFormDisplayEvent = function loginPasswordFormDisplayEvent(loginCheckout) {
  return {
    event_name: 'step.display',
    event_data: {
      funnel_name: loginCheckout ? 'checkout' : 'login stand alone',
      step_name: 'enter password',
      step_number: 2,
      feature_name: 'login'
    }
  };
};
var formSubmitEvent = exports.formSubmitEvent = function formSubmitEvent(loginCheckout) {
  return {
    event_name: 'step.submit',
    event_data: {
      funnel_name: loginCheckout ? 'checkout' : 'login stand alone',
      step_name: 'enter password',
      step_number: 2,
      feature_name: 'login'
    }
  };
};
var forgotPasswordEvent = exports.forgotPasswordEvent = {
  event_name: 'button.click',
  event_data: {
    button_name: 'forgotten password',
    feature_name: 'Customer login'
  }
};
var sendAgainForgottenPasswordEvent = exports.sendAgainForgottenPasswordEvent = function sendAgainForgottenPasswordEvent() {
  return {
    event_name: 'button.click',
    event_data: {
      button_name: 'send again forgotten password',
      feature_name: 'Customer login'
    }
  };
};
var loginByProviderEvent = exports.loginByProviderEvent = function loginByProviderEvent(providerName) {
  return {
    event_name: "button.click",
    event_data: {
      button_name: "Log in with ".concat(providerName),
      button_type: 'Social connector',
      feature_name: 'Customer login'
    }
  };
};
var onPageError = exports.onPageError = function onPageError(errorMessage) {
  (0, _tms.getTmsInstance)().pushFragment([{
    name: "cdl_error_message",
    value: errorMessage
  }]);
};
var onPageDisplay = exports.onPageDisplay = function onPageDisplay(pageName, pageType, pageSubtype) {
  (0, _tms.getTmsInstance)().pushFragment([{
    name: "cdl_page_name",
    value: pageName
  }, {
    name: "cdl_page_type",
    value: pageType
  }, {
    name: "cdl_page_subtype",
    value: pageSubtype
  }]);
};